import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';
import { useViewDriverSummaryByLocationQuery } from '../driverStatusEndpoints';

const Locations = ({ onClose, next, prev, driverState, setDriverState }) => {
  const { locations } = driverState;

  const { data: availableLocations = [], isLoading: isLoadingLocations } =
    useViewDriverSummaryByLocationQuery();

  const isInvalid = R.isEmpty(locations);

  const handleChange = location =>
    R.compose(
      setDriverState,
      R.assoc('locations'),
      R.ifElse(
        R.equals(true),
        R.always(R.append(location, locations)),
        R.always(R.reject(R.equals(location), locations))
      ),
      R.path(['target', 'checked'])
    );

  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button onClick={prev} sx={{ width: 150 }} variant="outlined">
        Back
      </Button>
      <Button disabled={isInvalid} onClick={next} sx={{ width: 150 }}>
        Continue
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      isLoading={isLoadingLocations}
      onHeaderButtonClick={onClose}
      title="New Driver"
    >
      <ProgressBar
        label="Locations (2 of 4)"
        sx={{
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            borderRadius: '10px',
          },
        }}
        value={50}
      />
      <Stack spacing={2} sx={{ py: 3 }}>
        <Typography sx={{ px: 3 }} variant="body1">
          Selectable Locations
        </Typography>

        <FormGroup>
          {availableLocations.map(location => (
            <Fragment key={location.locationId}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={locations.includes(location)}
                    name={location.name}
                    onChange={handleChange(location)}
                  />
                }
                label={location.name}
                sx={{ px: 3, py: 1 }}
              />
              <Divider />
            </Fragment>
          ))}
        </FormGroup>
      </Stack>
    </DrawerLayoutWrapper>
  );
};

Locations.propTypes = {
  driverState: PropTypes.shape({
    locations: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  next: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
  setDriverState: PropTypes.func.isRequired,
};

export default Locations;
